import { render, staticRenderFns } from "./ColourDensity.vue?vue&type=template&id=390d5c94&"
import script from "./ColourDensity.vue?vue&type=script&lang=js&"
export * from "./ColourDensity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports